import { Component, OnInit, Inject, OnDestroy } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatTableDataSource } from "@angular/material/table";
import moment from "moment";
import { Subscription } from "rxjs";
import { OPD_CONST } from "../../../properties/opd-static-properties";
import { OPD_API_URL } from "../../../properties/opd-url-properties";
import { MultiLanguageService } from "projects/lib/medcare-core-lib/src/lib/core/multi-language/multi-language.service";
import { AuthService } from "projects/lib/medcare-core-lib/src/lib/services/auth.service";
import { AppBaseService } from "projects/lib/medcare-core-lib/src/lib/services/http.service";

@Component({
  selector: "app-appointment-remarks-dialog",
  templateUrl: "./appointment-remarks-dialog.component.html",
  styleUrls: ["./appointment-remarks-dialog.component.scss"],
})
export class AppointmentRemarksDialogComponent implements OnInit, OnDestroy {
  remarkColumns: any = [];
  remarkSource: any = [];
  remarks: any;
  listRemarks: any;
  name: string;
  appointmentId: any;
  private subscriptionList = new Subscription();
  minDate: any = new Date();
  pageName: string;
  previousRemarksList: any[] = [];
  username: any;
  constructor(
    public dialogRef: MatDialogRef<AppointmentRemarksDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public snackBar: MatSnackBar,
    private langService: MultiLanguageService,
    private appBaseService: AppBaseService,
    public authService: AuthService
  ) {}

  ngOnInit() {
    this.remarkColumns =OPD_CONST.reamarksList;
    this.previousRemarksList = this.data.listRemarks;

    this.authService.getData().then((user: any) =>{
      if (user) {
        this.username = user.userName;
      }
    })

    this.pageName = this.data.name;
    if (this.previousRemarksList.length > 0) {
      this.remarkSource = new MatTableDataSource();
      this.previousRemarksList.forEach((element) => {
        let dateValue = this.epochToDateConverter(element.addedOn * 1000);
        this.remarkSource.data.push({
          remark: element.remark ? element.remark : element.remark,
          noteDate: dateValue,
          addedFrom: element.addedFrom,
          addedBy: element.addedBy,
        });
      });
      this.remarkSource = new MatTableDataSource(this.remarkSource.data);
    } else {
      this.remarkSource = new MatTableDataSource();
    }
  }

  /**
   *Close method
   *
   * @memberof PatientAppointmentListComponent
   */
  ngOnDestroy() {
    this.subscriptionList.unsubscribe();
  }

  /**
   *add remarks method
   *
   * @memberof AppointmentRemarksDialogComponent
   */
  onAddRemarkClick() {
    if (!this.remarks) {
      this.snackBar.open(
        this.langService.get("CommonAppoinment.warning"),
        this.langService.get("AppointmentListPage.enterReportRemarks"),
        {
          duration: 2000,
        }
      );
    } else {
      this.remarkSource.data.push({
        remark: this.remarks,
        noteDate: this.minDate,
        addedFrom: this.pageName,
        addedBy: this.username
      });
      this.previousRemarksList.push({
        status: true,
        addedFrom: this.pageName,
        addedBy: this.username,
        addedOn: this.dateToEpochConverter(new Date()),
        remark: this.remarks,
      });
      let requestobject;
      if (this.previousRemarksList.length > 1) {
        requestobject = {
          remarkList: this.previousRemarksList,
          id: this.data.appointmentId,
        };
      } else {
        requestobject = {
          remarkList: [
            {
              status: true,
              addedFrom: this.pageName,
              addedBy: this.username,
              addedOn: this.dateToEpochConverter(new Date()),
              remark: this.remarks,
            },
          ],
          id: this.data.appointmentId,
        };
      }
      this.appBaseService.setResourceURL(OPD_API_URL.OPD_SERVICE);
      this.subscriptionList.add(
        this.appBaseService
          .putResource(OPD_API_URL.OPD_REMARKS_UPDATE, requestobject)
          .subscribe(() => {
              this.snackBar.open(
                this.langService.get("CommonAppoinment.success"),
                this.langService.get("AppointmentListPage.reamarksSaved"),
                {
                  duration: 1000,
                }
              );
          })
      );
      this.remarkSource = new MatTableDataSource(
        this.remarkSource.data
      );
      this.remarks = undefined;
    }
  }

  /**
   *On close call
   *
   * @memberof AppointmentRemarksDialogComponent
   */
  onNoClick() {
    let data = this.previousRemarksList;
    this.dialogRef.close(data);
  }
  /**
   *date epoch converte
   *
   * @param {Date} date
   * @return {*}  {number}
   * @memberof AppointmentRemarksDialogComponent
   */
  dateToEpochConverter(date: Date): number {
    try {
      return moment(date).unix();
    } catch (ex) {
      return moment(new Date()).unix();
    }
  }
  /**
   *epoch date converte
   *
   * @param {number} epoch
   * @return {*}  {Date}
   * @memberof AppointmentRemarksDialogComponent
   */
  epochToDateConverter(epoch: number): Date {
    try {
      epoch = epoch / 1000;
      var d = new Date(0);
      d.setUTCSeconds(epoch);
      return d;
    } catch (ex) {
      return new Date();
    }
  }
}
